import { useEffect, useState } from 'react';

import { ONBOARDING_ANCHOR_REGISTER_EVENT } from '@components/UserOnboardingTooltip/constants';

const useAnchorRegisterStep = (
  enabled: boolean,
  stepId: string,
  getAnchor: (id: string) => HTMLElement | null
): HTMLElement | null => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!enabled) {
      setAnchor(null);
      return;
    }

    const syncAnchor = (el: HTMLElement | null) => {
      setAnchor(el ?? null);
    };

    syncAnchor(getAnchor(stepId));

    const handleRegister = (e: CustomEvent<{ stepId: string; element: HTMLElement | null }>) => {
      if (e.detail.stepId !== stepId) return;
      syncAnchor(e.detail.element);
    };

    window.addEventListener(ONBOARDING_ANCHOR_REGISTER_EVENT, handleRegister as EventListener);

    return () => {
      window.removeEventListener(ONBOARDING_ANCHOR_REGISTER_EVENT, handleRegister as EventListener);
      setAnchor(null);
    };
  }, [enabled, stepId, getAnchor]);

  return anchor;
};

export default useAnchorRegisterStep;
